<template>
    <div class="faceRec-container">
        <div v-if="!isLoad && !data.isStream" @click="faceRec" class="reRec">重新识别</div>
        <newMaterialLoad v-if="!hasResult&&isLoad"></newMaterialLoad>
        <newMaterialNoResult v-if="!hasResult&&!isLoad"></newMaterialNoResult>
        <ul v-if="hasResult&&!isLoad&&data.type-0===1" class="pic">
            <li v-for="(item,index) in faceList" :key="index">
                <div class="name">
                    <div class="left-container">
                    <div :class="{sensitive: true, on: item.optimal_face.secret_level > 0}">
                        <div :class="{sensitiveBorder: true, on: item.optimal_face.secret_level > 0}">
                            <div :style="{'background-image': `url(${item.optimal_face.pic_url})`}" class="img">
                                <p class="num">{{++index}}</p>
                            </div>
                        </div>
                    </div>
                    <p v-html="item.optimal_face.name" class="name"></p>
                    </div>
                    <div @click="item.status=!item.status" class="right-container">
                    <span>详情</span>
                    <img :class="{on: item.status}" src="../../../common/newMaterialBox/assets/arrow.png" alt="">
                    </div>
                </div>
                <div v-if="item.status" class=line>
                    <p></p>
                </div>
                <div v-if="data.type-0 === 2" class="camera-container">
                    <p class="title">
                        <span>出现镜头</span>
                        <i></i>
                    </p>
                    <ul>
                        <li>
                            <p>00:00:00-00:00:02</p>
                        </li>
                        <li>
                            <p>00:00:00-00:00:02</p>
                        </li>
                        <li>
                            <p>00:00:00-00:00:02</p>
                        </li>
                    </ul>
                </div>
                <div v-if="item.status && item.optimal_face.secret_level > 0" class="isSensitive">敏感人物</div>
                <div v-if="item.status" class="description">{{item.optimal_face.describe}}</div>
            </li>
        </ul>
        <ul v-if="hasResult&&!isLoad&&data.type-0===2" class="pic">
            <li v-for="(item,index) in videoFaceList" :key="index">
                <div class="name">
                    <div class="left-container">
                    <div :class="{sensitive: true, on: item.secret_level-0 > 0}">
                        <div :class="{sensitiveBorder: true, on: item.secret_level-0 > 0}">
                            <div :style="{'background-image': `url(${item.face_image})`}" class="img">
                                <p class="num">{{++index}}</p>
                            </div>
                        </div>
                    </div>
                    <p class="name">{{item.name}}</p>
                    </div>
                    <div @click="changeStatus(item)" class="right-container">
                    <span>详情</span>
                    <img :class="{on: item.status}" src="../../../common/newMaterialBox/assets/arrow.png" alt="">
                    </div>
                </div>
                <div v-show="item.status" class=line>
                    <p></p>
                </div>
                <div v-if="item.status && item.secret_level > 0" class="isSensitive">敏感人物</div>
                <div v-if="item.status" class="description">{{item.describe}}</div>
                <div v-if="data.type-0 === 2&&item.result.length > 0" class="camera-container">
                    <p @click="changeShowFace(item)" class="title">
                        <span>出现镜头</span>
                        <i :class="{on: item.showFace}"></i>
                    </p>
                    <ul v-if="item.showFace">
                        <li @click="seekTo(i.first_time)" v-for="(i,k) in item.result" :key="k"  :style="{'background-image': `url(${i.frame_href})`}">
                            <p>{{i.first_time}}-{{i.last_time}}</p>
                        </li>
                    </ul>
                </div>
            </li>
        </ul>
    </div>
</template>

<script>
import common from "@common/common";
import { apis } from "@common/config";

export default {
    name: 'newMaterialFaceRec',
    data() {
        return {
            hasResult: false,
            isLoad: true,
            faceList: [],
            videoFaceList: [],
            picFaceList: [],
            list: []
        }
    },
    props: {
        data: {
            type: Object
        },
        width: {
            type: Number
        },
        height: {
            type: Number
        },
        keywords: {
            type: String
        }
    },
    watch: {
        width(to) {
            // console.log(to)
            if(this.faceList.length > 0){
                this.picFaceList = []
                this.faceList.forEach(el => {
                    if (el.position) {
                        let posArr = el.position.split(",");
                        let faceOriginWidth = parseInt(el.pixel.split("*")[0]);
                        let faceOriginHeight = parseInt(el.pixel.split("*")[1]);
                        let width1 =
                            (faceOriginWidth * parseInt(this.height)) /
                            faceOriginHeight;

                        let height1 = parseInt(this.height);

                        let top = 0;
                        // console.log(width1,this.width)
                        if (width1 > parseInt(this.width)) {
                            console.log('进入》分支')
                            width1 = this.width;

                            height1 =
                            (this.width * faceOriginHeight) / faceOriginWidth;

                            top = (this.width * faceOriginHeight) / faceOriginWidth;

                            top = (this.height - top) / 2;
                        }

                        let halfW1 = (parseInt(this.width) - width1) / 2;
                        this.picFaceList.push({
                            borderLeft:
                            halfW1 + (posArr[0] * width1) / faceOriginWidth,
                            borderTop:
                            (posArr[1] * height1) / faceOriginHeight + top,
                            borderWidth:
                            (width1 * (posArr[2] - posArr[0])) / faceOriginWidth,
                            borderHeight:
                            (height1 * (posArr[3] - posArr[1])) / faceOriginHeight
                        });
                    }
                });
                this.$emit('faceList',this.picFaceList)
            }
        }
    },
    methods: {
        changeStatus(i) {
            i.status = !i.status
            this.$forceUpdate();
        },
        changeShowFace(i) {
            i.showFace = !i.showFace
            this.$forceUpdate();
        },
        seekTo(t) {
            let time = common.timeEvent(t) * 100
            this.$emit('toTime', time)
            console.log(time)
        },
        /**
         * 照片 人脸识别
         */
        picFaceRec() {
            this.hasResult = false;
            this.isLoad = true;

            const info = {
                idstring: this.data.idstring,
                keywords: this.keywords ? this.keywords : ''
            };
            common.myFetch(apis.imgface, info).then(r => {
                if (r) {
                    this.data.face_status = 3;
                    this.$emit('clickFun')
                    if(r.length > 0){
                        this.faceList = r;
                        this.picFaceList = [];
                        this.faceList.forEach(el => {
                            this.$set(el, "status", false);
                            if (el.position) {
                                let posArr = el.position.split(",");
                                let faceOriginWidth = parseInt(el.pixel.split("*")[0]);
                                let faceOriginHeight = parseInt(el.pixel.split("*")[1]);
                                let width1 =
                                    (faceOriginWidth * parseInt(this.height)) /
                                    faceOriginHeight;

                                let height1 = parseInt(this.height);

                                let top = 0;
                                console.log(width1,this.width)
                                if (width1 > parseInt(this.width)) {
                                    console.log('进入》分支')
                                    width1 = this.width;

                                    height1 =
                                    (this.width * faceOriginHeight) / faceOriginWidth;

                                    top = (this.width * faceOriginHeight) / faceOriginWidth;

                                    top = (this.height - top) / 2;
                                }

                                let halfW1 = (parseInt(this.width) - width1) / 2;
                                this.picFaceList.push({
                                    borderLeft:
                                    halfW1 + (posArr[0] * width1) / faceOriginWidth,
                                    borderTop:
                                    (posArr[1] * height1) / faceOriginHeight + top,
                                    borderWidth:
                                    (width1 * (posArr[2] - posArr[0])) / faceOriginWidth,
                                    borderHeight:
                                    (height1 * (posArr[3] - posArr[1])) / faceOriginHeight
                                });
                            }
                        });
                        this.$emit('faceList',this.picFaceList)
                        this.hasResult = true;
                        this.isLoad = false;
                    }else{
                        this.hasResult = false;
                        this.isLoad = false;
                    }
                } else {
                    this.data.face_status = 4;
                    this.hasResult = false;
                    this.isLoad = false;
                }
            });
        },
        /**
         * 视频人脸识别
         */
        videoFaceRec() {

            const info = {
                idstring: this.data.idstring,
                keywords: this.keywords ? this.keywords : ''
            };

            common.myFetch(apis.faceRec, info).then(r => {
                if (r) {
                    this.$emit('faceStatus',2)
                    this.hasResult = false;
                    this.isLoad = true;
                    this.$toast(r);
                }else{
                    this.hasResult = true;
                    this.isLoad = false;
                }
            });
        },
        faceRec() {
            if (this.data.type - 0 === 1) {
                this.picFaceRec();
            } else if (this.data.type - 0 === 2) {
                this.videoFaceRec();
            }
        },
        getVideoDetail() {
            this.$emit('clickFun')
            const info = {
                idstring: this.data.idstring,
                keywords: this.keywords ? this.keywords : ''
            };
            common.myFetch(apis.faceRes, info).then(r => {
                if (r) {
                    if(r.length > 0){
                        r.forEach(el => {
                            el.status = false;
                            el.showFace = false;
                        })
                        this.videoFaceList = r;
                        this.hasResult = true;
                        this.isLoad = false;
                    }else{
                        this.hasResult = false;
                        this.isLoad = false;
                    }
                }else{
                    this.hasResult = false;
                    this.isLoad = false;
                }
            });
        }
    },
    mounted() {
        if(this.data.isStream){
            if (this.data.type - 0 === 1) {
                if(this.data.facerec_res.length > 0){
                    this.faceList = this.data.facerec_res;
                    this.picFaceList = [];
                    this.faceList.forEach(el => {
                        this.$set(el, "status", false);
                        if (el.position) {
                            let posArr = el.position.split(",");
                            let faceOriginWidth = parseInt(el.pixel.split("*")[0]);
                            let faceOriginHeight = parseInt(el.pixel.split("*")[1]);
                            let width1 =
                                (faceOriginWidth * parseInt(this.height)) /
                                faceOriginHeight;

                            let height1 = parseInt(this.height);

                            let top = 0;
                            console.log(width1,this.width)
                            if (width1 > parseInt(this.width)) {
                                console.log('进入》分支')
                                width1 = this.width;

                                height1 =
                                (this.width * faceOriginHeight) / faceOriginWidth;

                                top = (this.width * faceOriginHeight) / faceOriginWidth;

                                top = (this.height - top) / 2;
                            }

                            let halfW1 = (parseInt(this.width) - width1) / 2;
                            this.picFaceList.push({
                                borderLeft:
                                halfW1 + (posArr[0] * width1) / faceOriginWidth,
                                borderTop:
                                (posArr[1] * height1) / faceOriginHeight + top,
                                borderWidth:
                                (width1 * (posArr[2] - posArr[0])) / faceOriginWidth,
                                borderHeight:
                                (height1 * (posArr[3] - posArr[1])) / faceOriginHeight
                            });
                        }
                    });
                    this.$emit('faceList',this.picFaceList)
                    this.hasResult = true;
                    this.isLoad = false;
                }else{
                    this.hasResult = false;
                    this.isLoad = false;
                }
            } else if (this.data.type - 0 === 2) {
                if(this.data.facerec_res && this.data.facerec_res.length > 0){
                    // this.list = this.data.facerec_res
                    // // let r = this.data.facerec_res
                    // this.list.forEach(el => {
                    //     el.status = false;
                    //     el.showFace = false;
                    // })
                    this.videoFaceList = this.data.facerec_res;
                    this.videoFaceList.forEach(el => {
                        el.status = false;
                        el.showFace = false;
                    })
                    console.log(this.videoFaceList)
                    this.hasResult = true;
                    this.isLoad = false;
                }else{
                    this.hasResult = false;
                    this.isLoad = false;
                }
            }
        }else{
            common.handleSocket(this.getVideoDetail, "facerec");
            if(this.data.face_status-0 === 1){
                this.faceRec()
            }else if(this.data.face_status-0 === 3 || this.data.face_status-0 === 4){
                if (this.data.type - 0 === 1) {
                    this.picFaceRec();
                } else if (this.data.type - 0 === 2) {
                    this.getVideoDetail();
                }
            }
        }
    }
}
</script>

<style lang="less" scoped>
    .faceRec-container {
        display: flex;
        flex-direction: column;
        height: 100%;
        padding: 14px 20px 28px;
        box-sizing: border-box;

        .reRec {
            width: 100%;
            height: 32px;
            line-height: 32px;
            text-align: center;
            background: #41B48C;
            border-radius: 4px; 
            font-size: 14px;
            color: #FFFFFF;
            margin-bottom: 14px;
            user-select: none;
            cursor: pointer;
        }
    }
    ul.pic {
        width: 100%;
        height: 100%;
        display: flex;
        flex-direction: column;
        overflow-y: auto;
        // padding-right: 20px;
        // padding: 0 20px 0 20px;
        box-sizing: border-box;

        &::-webkit-scrollbar {
            width: 4px;
        }
        &::-webkit-scrollbar-thumb {
            background: #ddd;
            border-radius: 4px;
        }

        li {
            display: flex;
            flex-direction: column;
            background: rgba(207, 215, 219, 0.2);
            padding: 20px 0 0;
            border-radius: 6px;
            box-sizing: border-box;
            margin-bottom: 14px;
            // overflow: hidden;

            &:nth-last-of-type(1) {
                margin-bottom: 8px;
            }

            & > .name {
            display: flex;
            flex-direction: row;
            justify-content: space-between;
            align-items: center;
            padding-left: 20px;
            padding-right: 20px;
            padding-bottom: 10px;
            // border-bottom: 1px solid #E8EBEF;
            box-sizing: border-box;

            .left-container {
                display: flex;
                flex-direction: row;
                align-items: center;

                .sensitive {
                display: flex;
                justify-content: center;
                align-items: center;
                width: 62px;
                height: 62px;
                border-radius: 50%;
                background: rgba(255, 85, 90, 0);
                margin-right: 10px;
                margin-left: 6px;

                &.on {
                    background: rgba(255, 85, 90, 0.2);
                }

                .sensitiveBorder {
                    display: flex;
                    justify-content: center;
                    align-items: center;
                    width: 56px;
                    height: 56px;
                    border-radius: 50%;
                    background: rgba(255, 85, 90, 0);

                    &.on {
                    background: rgba(255, 85, 90, 0.5);
                    }
                }
                }

                .img {
                position: relative;
                width: 50px;
                height: 50px;
                background-repeat: no-repeat;
                background-position: center;
                background-size: cover;
                border-radius: 50%;

                .num {
                    position: absolute;
                    left: -10px;
                    width: 20px;
                    height: 20px;
                    line-height: 20px;
                    text-align: center;
                    border-radius: 50%;
                    background: #ff4153;
                    font-size: 14px;
                    color: #fff;
                }
                }

                .name {
                    font-size: 14px;
                    line-height: 20px;
                    font-weight: 500;
                    color: #050f0f;
                }
            }

            .right-container {
                display: flex;
                flex-direction: row;
                align-items: center;
                user-select: none;
                cursor: pointer;

                span {
                    font-size: 14px;
                    line-height: 20px;
                    color: #829191;
                    margin-right: 6px;
                }

                img {
                user-select: none;
                cursor: pointer;

                &.on {
                    transform: rotate(180deg);
                }
                }
            }
            }

            &>.line {
                width: 100%;
                height: 1px;
                padding: 0 20px;
                box-sizing: border-box;

                p {
                    width: 100%;
                    height: 1px;
                    background: #E8EBEF;
                    box-sizing: border-box;
                }
            }

            .isSensitive {
                display: flex;
                justify-content: center;
                align-items: center;
                width: 62px;
                height: 18px;
                line-height: 18px;
                text-align: center;
                background: rgba(255, 85, 90, 0.1);
                border-radius: 2px;
                border: 1px solid #ff555a;
                font-size: 12px;
                color: #ff555a;
                margin-top: 9px;
                margin-left: 20px;
            }

            .description {
                font-size: 16px;
                line-height: 28px;
                color: #050f0f;
                padding: 12px 20px 12px;
                // border-bottom: 1px solid #dcdcdc;
                box-sizing: border-box;
            }

            .camera-container {
                background: rgba(185,195,195,0.15);

                .title {
                    width: 100%;
                    height: 40px;
                    display: flex;
                    flex-direction: row;
                    align-items: center;
                    justify-content: center;
                    user-select: none;
                    cursor: pointer;

                    span {
                        display: block;
                        font-size: 14px;
                        line-height: 20px;
                        color: #829191;
                    }

                    i {
                        display: block;
                        width: 20px;
                        height: 20px;
                        background: url('../../../assets/img/material/arrow.svg') no-repeat;
                        background-position: center center;
                        background-size: 100% 100%;

                        &.on {
                            transform: rotate(180deg);
                        }
                    }
                }

                ul {
                    display: flex;
                    flex-direction: row;
                    justify-content: space-between;
                    flex-wrap: wrap;
                    width: 100%;
                    padding: 0 20px;
                    box-sizing: border-box;

                    li {
                        position: relative;
                        width: 150px;
                        height: 84px;
                        margin-bottom: 16px;
                        border-radius: 0;
                        background-position: center center;
                        background-size: 100% 100%;

                        p {
                            position: absolute;
                            bottom: 0;
                            left: 0;
                            width: 150px;
                            height: 23px;
                            background: rgba(0,0,0,0.4);
                            font-size: 12px;
                            color: #FFFFFF;
                            line-height: 23px;
                            text-align: center;
                        }
                    }
                }
            }
        }
    }
</style>

<style lang="less">
.faceRec-container {
    em {
        color: #41b48c;
        font-style: normal;
    }
}
</style>